export default {"src":"https://webcdn.trailways.com/_next/static/media/address-primary.c6bc002d.svg","height":14,"width":10,"blurWidth":0,"blurHeight":0};